import {Brick, registerBrick} from 'olympe';

export default class CodedConvertToPlannerPayload extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} response
     * @param {function()} forwardEvent
     * @param {function(ListDef)} setPlans
     */
    update ($, [response], [forwardEvent, setPlans]) {
        let finalList = [];
        if (Array.isArray(response) && response.length > 0) {
            const list = [];
            response.forEach(item => {
                const newItem = {
                    id: item.id,
                    title: item.title,
                    containerId: item.container.containerId,
                    createdDateTime: item.createdDateTime,
                    createdBy: item.createdBy.user.id
                };
                list.push(newItem);
            });
            finalList = list;
        }
        setPlans(finalList);
        forwardEvent();
    }
}

registerBrick('018dc0fc7884f065a7ba', CodedConvertToPlannerPayload);
